
        // Don't change! This file is auto-generated
        const urlSlugItems = {
  "stores": "vestigingen",
  "newsletter": "nieuwsbrief",
  "returnPage": "retourneren",
  "newsPage": "nieuws",
  "toursPage": "tours",
  "watches": "horloges",
  "brands": "merken",
  "sizeInformation": "ringmaat-informatie",
  "faqPage": "veelgestelde-vragen",
  "armbanden": "armbanden",
  "colliers": "colliers",
  "diamanten_armbanden": "diamanten-armbanden",
  "diamanten_colliers": "diamanten-colliers",
  "diamanten_ringen__copy_": "diamanten-ringen",
  "oorbellen": "oorbellen",
  "ringen": "ringen",
  "trouwringen_sets": "trouwringen-sets",
  "untitled_content_item_250447f": "diamanten-ringen",
  "untitled_content_item_c68c114": "diamanten-oorbellen"
};
        export default urlSlugItems
        export type UrlSlugMessages = typeof urlSlugItems
      